import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const IncludesFeatureIcon = () => {
  return /*#__PURE__*/_jsx(IconCircle, {
    paddingInline: "200",
    paddingBlock: "200",
    icon: SuccessIcon,
    color: "fill-surface-default",
    backgroundColor: "icon-core-default",
    borderWidth: "0",
    size: "100",
    role: "img"
  });
};